import { Box, Button, debounce, Slider, Typography } from "@mui/material";
import { palette, themeWidth } from "../../themes/theme";
import DarkPrimaryButton from "../PrimaryButton/DarkPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { setOpacity } from "../../redux/slices/mapSlice";
import { CustomDraggable } from "../Draggable";
import { MapLayoutWidth } from "../../utils/helper";

export const BulbSetting = ({ setShowOpacityControl }) => {
  const mapState = useSelector((state) => state.map);
  const dispatch = useDispatch();

  const changeStyle = debounce((e) => {
    dispatch(setOpacity(parseFloat(e.target.value)));
  }, 500);

  const handleOk = () => {
    setShowOpacityControl(false);
  };

  return (
    <CustomDraggable
      width={320}
      height={180}
      top={220}
      left={themeWidth[MapLayoutWidth]}
      bounds={{
        left: themeWidth[MapLayoutWidth],
      }}
      headerTitle={"Map Transparency Control"}
      customFooter={
        <Button
          variant="outlined"
          sx={{ borderRadius: "0px", fontWeight: "bold" }}
          onClick={handleOk}
        >
          Ok
        </Button>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 1,
        }}
      >
        <Typography sx={{ color: palette.text.dark, fontSize: 15 }}>
          Transparency: {mapState.opacityValue * 100}%
        </Typography>
        <Slider
          min={0}
          step={0.1}
          max={1}
          defaultValue={mapState.opacityValue}
          valueLabelDisplay="off"
          onChange={changeStyle}
          sx={{ width: "85%", alignSelf: "center" }}
        />
      </Box>
    </CustomDraggable>
  );
};
